import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useAuth } from 'react-oidc-context';

export function Profile() {
  const auth = useAuth();
  const {id_token, access_token, refresh_token, profile, ...other } = auth.user || {};
  return (
    <Col>
      <Row> Hi There! </Row>
      <Row> User name: {(profile as any)?.['cognito:username']} </Row>
      <Row> Phone number: {profile?.phone_number} {profile?.phone_number_verified? ("(verified)"): ""}</Row>
      <Row> Email: {profile?.email} {profile?.email_verified? ("(verified)"): ""}</Row>
      {/* <Row> token: {id_token}</Row> */}
      <Row> OTHER: {JSON.stringify(other || {})}</Row>
    </Col>
  );
}